// extracted by mini-css-extract-plugin
export default {"main":"GeneratedAssetList_main__ssAIC","list":"GeneratedAssetList_list__54v5h"};